import React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Container, Col, Form } from 'react-bootstrap';
// import { Container, Row, Col, Form } from 'react-bootstrap';
import './ContactUs.css';

import { Server_URL } from "../config.js";
import contactusbg from '../images/PageImg/ContactUs-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { GoTopBtn } from '../components/GoTopBtn';

function ContactUs() {
  const navigate = useNavigate();
  const [customer, setCustomer] = useState({
    InfoNo: '',
    FirstName: '', LastName: '', TelNo: '', Email: '',
    Company: '', Comment: '',
    Date: ''
  })

  const [chklist, setChkList] = useState({
    SNo: '',
    ProjectType: '', ProductName: '',
    Size: '', LcmPN: '',
    CoverOD: '', CoverVA: '', DisplayAA: '', CoverThick: '',
    SensorOD: '', SensorAA: '', SensorThick: '',
    TotalThick: '', ChannelRxTx: '', ControlIC: '',
    Note: '', DrawYes: ''
  })

  function handleSubmitCustomerInfo(e) {
    e.preventDefault();
    // console.log("get into /ContactUs Submit CustomerInfo customer : ", customer);
    axios
      .post(`${Server_URL}/add_CustomerInfo`, customer)
      // .post('http://localhost:3022/add_CustomerInfo', customer)
      // .post('http://localhost:5000/add_CustomerInfo', customer)
      .then((res) => { navigate(-1); })
      // .then((res) => { navigate('/'); console.log(res); }) xx
      .catch((err) => console.log(err))
  }

  function handleSubmitCheckList(e) {
    e.preventDefault()
    // console.log("get into /ContactUs Submit CheckList chklist :", chklist);
    axios
      .post(`${Server_URL}/add_ReqCheckList`, chklist)
      // .post('http://localhost:3022/add_ReqCheckList', chklist)
      // .post('http://localhost:5000/add_ReqCheckList', chklist)
      .then((res) => { navigate(-1); })
      // .then((res) => { navigate('/'); console.log(res); }) xx
      .catch((err) => console.log(err))
  }

  // console.log("get into ContactUs()");
  return (
    <div className='contactus-page'>
      <div className='contactusheader'
        style={{ backgroundImage: `url(${contactusbg})`, height: "60vh" }} >
        {/* style={{ backgroundImage: `url(${contactusbg})`, height: "auto" }} > */}
        <HeaderSlide text={'Contact Us'} />
        <h4 className='text-light'>&nbsp;&nbsp;images/PageImg/ContactUs-page-bg.jpg</h4>
      </div>
      {/* <br /> */}
      <Container className='my-5'>
        <Form onSubmit={handleSubmitCustomerInfo}>
          <Form.Group className='h-200 d-flex align-items-center justify-content-center'>
            <h1 className='text-dark'>Contact Information</h1>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-4'>
              <Form.Label htmlFor='InfoNo'>Info Number</Form.Label>
              <Form.Control type='number' onChange={(e) => setCustomer({ ...customer, InfoNo: e.target.value })} required />
            </Col>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-2'>
              <Form.Label htmlFor='first-name'>First Name</Form.Label>
              <Form.Control type='name' onChange={(e) => setCustomer({ ...customer, FirstName: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='last-name'>Last Name</Form.Label>
              <Form.Control type='name' onChange={(e) => setCustomer({ ...customer, LastName: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='phone-number'>Phone Number</Form.Label>
              <Form.Control type='tel' onChange={(e) => setCustomer({ ...customer, TelNo: e.target.value })} />
            </Col>
            <Col className='col-md-6'>
              <Form.Label htmlFor='email-address'>Email Address</Form.Label>
              <Form.Control type='email' onChange={(e) => setCustomer({ ...customer, Email: e.target.value })} />
            </Col>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-4'>
              <Form.Label htmlFor='company'>Company</Form.Label>
              <Form.Control type='text100' onChange={(e) => setCustomer({ ...customer, Company: e.target.value })} />
            </Col>
            <Col className='col-md-8'>
              <Form.Label htmlFor='comments'>Comments</Form.Label>
              <Form.Control type='text100' onChange={(e) => setCustomer({ ...customer, Comment: e.target.value })} />
            </Col>
          </Form.Group>
          <Form.Group className='row mb-3'>
            <Col className='col-md-2'>
              <Form.Label htmlFor='date'>Date</Form.Label>
              <Form.Control type='date' onChange={(e) => setCustomer({ ...customer, Date: e.target.value })} />
            </Col>
          </Form.Group>

          <br />
          <Form.Group className='row mb-3'>
            <Col> <button type='submit' className='btn btn-success btn-lg'>Submit</button> </Col>
          </Form.Group>
        </Form>

        <Form onSubmit={handleSubmitCheckList}>
          <Form.Group className='h-200 d-flex align-items-center justify-content-center'>
            <h1 className='text-dark'>Quotation Check list</h1>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-4'>
              <Form.Label htmlFor='SNo'>Serial Number</Form.Label>
              <Form.Control type='number' onChange={(e) => setChkList({ ...chklist, SNo: e.target.value })} required />
            </Col>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-4'>
              <Form.Label htmlFor='ProjectType'>Project Type :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, ProjectType: e.target.value })} />
            </Col>
            <Col className='col-md-4'>
              <Form.Label htmlFor='ProductNname'>Product Name :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, ProductNane: e.target.value })} />
            </Col>
          </Form.Group>
          <Form.Group className='row mb-3'>
            <Col className='col-md-2'>
              <Form.Label htmlFor='Size'>Size :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, Size: e.target.value })} />
            </Col>
            <Col className='col-md-4'>
              <Form.Label htmlFor='LcmPN'>LCM Part Number :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, LcmPN: e.target.value })} />
            </Col>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-2'>
              <Form.Label htmlFor='CoverOD'>Cover Glass OD :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, CoverOD: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='CoverVA'>Cover Glass View area :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, CoverVA: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='DisplayAA'>Display Active area :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, DisplayAA: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='CoverThick'>Cover Glass Thickness :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, CoverThick: e.target.value })} />
            </Col>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-2'>
              <Form.Label htmlFor='SensorOD'>Sensor OD :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, SensorOD: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='SensorAA'>Sensor Active area :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, SensorAA: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='SensorThick'>Sensor Glass Thickness :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, SensorThick: e.target.value })} />
            </Col>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-2'>
              <Form.Label htmlFor='TotalThick'>Total Thickness :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, TotalThick: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='ChannelRxTx'>Channel Rx/Tx :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, ChannelRxTx: e.target.value })} />
            </Col>
            <Col className='col-md-2'>
              <Form.Label htmlFor='ControlIC'>Control IC :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, ControlIC: e.target.value })} />
            </Col>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-6'>
              <Form.Label htmlFor='Note'>Note :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, Note: e.target.value })} />
            </Col>
          </Form.Group>

          <Form.Group className='row mb-3'>
            <Col className='col-md-6'>
              <Form.Label htmlFor='DrawYes'>DrawYes :</Form.Label>
              <Form.Control type='text100' onChange={(e) => setChkList({ ...chklist, DrawYes: e.target.value })} />
            </Col>
          </Form.Group>

          <br />
          <Form.Group className='row mb-3'>
            <Col> <button type='submit' className='btn btn-success btn-lg'>Submit</button> </Col>
          </Form.Group>
        </Form>
      </Container>

      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default ContactUs;

/* <br /> <br /> <br /> */
/*
<header className='mt-5'>
  <div className='container h-100 d-flex align-items-center justify-content-center'>
    <h1 className='text-light'>Contact Us</h1>
  </div>
</header>
*/